import { Link } from 'react-router-dom';
import Layout from '../../../components/layout/Layout';
import Breadcrumb from '../../../components/layout/Breadcrumb';

// ===== 関連サイト / 執事ベル 全面刷新（新デザイン憲章適用・_shared廃止・inline化） =====
// 実文は working tree 現行実文を保持。外部公式URL butlerbell.jp は変更禁止。当ルートは pagesWithOwnFaq 登録済み＝FAQ自前描画。
// 画像は執事ベル（石井裕一）本人の顔を主題化しない構図の手持ち画像を使用（実写ポートレートを騙らない）。

const points = [
  { title: '執事文化の発信', en: 'Communication', desc: 'YouTube「執事ベル」チャンネルなどを通じて、執事の日常や所作、おもてなしの心を発信しています。', img: '/images/generated/jba-fs-189-related_butler-bell.jpg', alt: '執事の日常とおもてなしを伝える様子' },
  { title: 'マナー・教養の紹介', en: 'Refinement', desc: 'テーブルマナーや立ち居振る舞いなど、暮らしにも活かせる執事の教養を、わかりやすく伝えています。', img: '/images/generated/jba-fs-190-related_butler-bell-v6.jpg', alt: '暮らしに活かせる執事のマナーと教養' },
  { title: '執事文化の現代化', en: 'Modernization', desc: '伝統的な執事の在り方を、動画やSNSといった現代のメディアを通じて次の世代へとつなぐ取り組みを続けています。', img: '/images/generated/jba-fs-191-related_butler-bell-v6.jpg', alt: '伝統を現代のメディアで次世代へつなぐ執事の姿' },
];

const faqs = [
  {
    q: '執事ベルとは何ですか？',
    a: '執事ベルは、一般社団法人全日本執事協会の三代目会長を務める石井裕一のオフィシャル情報発信ブランドです。長年にわたり国内外のお客様に執事として仕えてきた経験をもとに、本物の執事の姿と、日本ならではのおもてなしの心を広く社会に伝える活動を続けています。',
  },
  {
    q: 'どのような発信をしていますか？',
    a: 'YouTube「執事ベル」チャンネルをはじめとする情報発信では、華やかなサービスの表側だけでなく、その裏側にある執事の規律や所作、心構えまでを丁寧に紹介しています。マナーやおもてなしを学びたい方、執事という仕事に関心のある方に向けた内容を届けています。',
  },
  {
    q: '全日本執事協会との関係は？',
    a: '執事ベルこと石井裕一は、当協会の三代目会長です。協会が掲げる理念のもと、その執事観は当協会の育成方針にも息づいています。動画や記事で執事の世界に触れてから体系立てて学びたい方には、当協会の教育・養成機関である日本執事アカデミーが受け皿となります。',
  },
];

const otherRelated = [
  { name: '全日本執事協会 THE BUTLER', role: '執事派遣サービス', to: '/related/the-butler' },
  { name: '日本執事アカデミー', role: '教育・養成機関', to: '/related/butler-academy' },
];

const breadcrumbs = [
  { label: 'ホーム', href: '/' },
  { label: '関連サイト', href: '/related' },
  { label: '執事ベル' },
];

const BTN08_ON_NAVY = "relative inline-flex items-center justify-center bg-[#a38e65] text-white font-semibold border border-[#1a2942] px-[42px] py-[16px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#1a2942] hover:text-[#f8f6f0] hover:border-[#a38e65] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#1a2942]/40 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#a38e65]/50";

function NavyBand({ no, ja, en }: { no: string; ja: string; en: string }) {
  return (
    <div className="bg-[#1a2942] border-y border-[#a38e65]/25">
      <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 py-5 sm:py-[26px] flex items-center gap-4 sm:gap-6">
        <img src="/images/brand/jba-logo.png" alt="" aria-hidden="true" className="h-8 w-8 sm:h-9 sm:w-9 object-contain shrink-0 opacity-90" />
        <span className="font-['Playfair_Display',serif] text-[#d7b779] text-xl sm:text-[26px] tracking-[0.1em] shrink-0 leading-none">{no}</span>
        <h2 className="jba-display font-medium text-[#f8f6f0] text-lg sm:text-2xl lg:text-[26px] tracking-[0.08em] leading-tight">{ja}</h2>
        <span className="hidden md:block ml-auto font-['Playfair_Display',serif] italic text-[#a38e65] text-base lg:text-[19px] tracking-[0.12em]">{en}</span>
      </div>
    </div>
  );
}

export default function RelatedButlerBellPage() {
  return (
    <Layout>
      {/* ===== ヒーロー ===== */}
      <section className="relative bg-[#1a2942] overflow-hidden min-h-[460px] lg:min-h-[520px] flex items-center">
        <img src="/images/generated/jba-still-typewriter-02.jpg" alt="アンティークタイプライター。言葉で伝える活動の象徴" className="absolute inset-0 w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(16,20,26,0.92)_0%,rgba(16,20,26,0.7)_50%,rgba(16,20,26,0.4)_100%)]"></div>
        <div className="relative z-10 w-full max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 pt-32 pb-14 lg:pt-36 lg:pb-20">
          <div className="max-w-[680px]">
            <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.32em] text-xs sm:text-[13px] text-[#d7b779] mb-4">Butler Bell</span>
            <div className="w-12 h-px bg-[#a38e65] mb-6"></div>
            <h1 className="jba-display font-normal text-white text-[clamp(26px,3.2vw,42px)] leading-[1.42] tracking-[0.04em] mb-6">
              執事の姿を、社会へ伝える
            </h1>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-white/90 leading-[1.95]">
              一般社団法人全日本執事協会 三代目会長・石井裕一のオフィシャル情報発信ブランド。本物の執事の姿と、日本ならではのおもてなしの心を、広く社会に伝えています。
            </p>
          </div>
        </div>
      </section>
      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      {/* ===== I. 執事ベルとは — リード3段落＋画像 ===== */}
      <NavyBand no="I" ja="執事ベルとは" en="About" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="order-2 lg:order-1 text-left">
              <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[30px] leading-[1.5] tracking-[0.02em] mb-5">
                サービスの表側と、<span className="text-[#a38e65]">その裏側にある心構えまで</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.95] mb-4">
                執事ベルは、一般社団法人全日本執事協会の三代目会長を務める石井裕一のオフィシャルブランドです。長年にわたり国内外のお客様に執事として仕えてきた経験をもとに、本物の執事の姿と、日本ならではのおもてなしの心を、広く社会に伝える活動を続けています。
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.95] mb-4">
                YouTube「執事ベル」チャンネルをはじめとする情報発信では、華やかなサービスの表側だけでなく、その裏側にある執事の規律や所作、心構えまでを丁寧に紹介しています。マナーやおもてなしを学びたい方、執事という仕事に関心のある方に向けて、実用的で奥行きのある内容を届けています。
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.95]">
                執事ベルの活動は、執事文化を現代の暮らしに合わせて伝え直す試みでもあります。伝統を重んじながら、動画やSNSといった現代のメディアを通じて、執事の魅力を次の世代へとつないでいます。
              </p>
            </div>
            <div className="order-1 lg:order-2">
              <img src="/images/generated/jba-fs-192-related_butler-bell-v8.jpg" alt="静かに寄り添う執事の日常の所作" className="w-full h-[300px] sm:h-[400px] md:h-[480px] object-cover border border-[#a38e65]/30" />
            </div>
          </div>
        </div>
      </section>

      {/* ===== II. 執事ベルの活動 — 白カード（各ポイントに画像）===== */}
      <NavyBand no="II" ja="執事ベルの活動" en="Highlights" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid md:grid-cols-3 gap-8 lg:gap-10">
            {points.map((p) => (
              <article key={p.title} className="flex flex-col bg-white border border-[#e2ddd2] group hover:border-[#a38e65]/70 transition-colors duration-300">
                <div className="relative h-52 overflow-hidden">
                  <img src={p.img} alt={p.alt} className="absolute inset-0 w-full h-full object-cover object-top" />
                </div>
                <div className="p-7 flex flex-col flex-1 text-left">
                  <span className="block font-['Playfair_Display',serif] italic text-[#8f7a56] text-[13px] tracking-[0.06em] mb-1.5">{p.en}</span>
                  <h4 className="jba-display font-medium text-[#1a2942] text-xl mb-3 leading-[1.4]">{p.title}</h4>
                  <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{p.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ===== III. 協会とのつながり — 紺パネル＋画像 ===== */}
      <NavyBand no="III" ja="協会とのつながり" en="Relationship" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 items-stretch border border-[#e2ddd2] overflow-hidden">
            <div className="relative min-h-[300px] lg:min-h-[400px] bg-black order-1">
              <img src="/images/generated/jba-fs-193-related_butler-bell-v8.jpg" alt="執事ベルの執事観が息づく協会の育成の場" className="absolute inset-0 w-full h-full object-cover object-top" />
            </div>
            <div className="order-2 bg-[#1a2942] flex flex-col justify-center px-8 sm:px-12 lg:px-14 py-12 lg:py-16 text-left">
              <span className="block font-['Playfair_Display',serif] italic text-[#a38e65] text-sm tracking-[0.06em] mb-4">Connection with the Association</span>
              <h3 className="jba-display font-medium text-[#f8f6f0] text-2xl sm:text-3xl leading-[1.5] tracking-[0.02em] mb-6">
                会長の執事観が、<span className="text-[#d7b779]">育成方針にも息づく</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.95] mb-4">
                執事ベルこと石井裕一は、一般社団法人全日本執事協会の三代目会長です。協会が掲げる理念のもと、その執事観は、当協会の育成方針にも息づいています。
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.95]">
                執事ベルが発信する「本物のおもてなし」の考え方は、当協会の教育・養成機関である日本執事アカデミーで学ぶ所作や心構えとも深くつながっています。動画や記事で執事の世界に触れてから体系立てて学びたい方にとって、日本執事アカデミーはその受け皿となる場所です。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== IV. 公式サイトのご案内 — 外部CTA ===== */}
      <NavyBand no="IV" ja="公式サイトのご案内" en="Official Site" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="bg-[#f8f6f0] border border-[#a38e65]/30 p-8 sm:p-10 md:p-14 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl leading-[1.5] mb-4">執事ベル 公式サイト</h3>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#4a4638] leading-[1.95] max-w-2xl mx-auto mb-8">
              執事ベルの活動や発信内容の詳細については、公式サイトをご覧ください。
            </p>
            <a href="https://butlerbell.jp/" target="_blank" rel="noopener noreferrer" className="relative inline-flex items-center justify-center gap-2 bg-[#1a2942] text-[#f8f6f0] border border-[#a38e65] px-[46px] py-[18px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#a38e65] hover:text-[#1a2942] hover:border-[#1a2942] cursor-pointer whitespace-nowrap">
              執事ベル 公式サイトを見る <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>
      </section>

      {/* ===== V. よくあるご質問（自前描画）===== */}
      <NavyBand no="V" ja="よくあるご質問" en="FAQ" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="max-w-4xl mx-auto border-t border-[#e2ddd2]">
            {faqs.map((f) => (
              <div key={f.q} className="border-b border-[#e2ddd2] py-6">
                <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl leading-[1.5] mb-3 flex items-start gap-3">
                  <span className="font-['Playfair_Display',serif] text-[#a38e65] text-xl leading-none pt-0.5">Q.</span><span>{f.q}</span>
                </h3>
                <p className="font-['Noto_Serif_JP',serif] text-sm sm:text-base text-[#4a4638] leading-[1.95] pl-8">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== ほかの関連サイト＋CTA ===== */}
      <section className="py-12 sm:py-16 bg-[#f8f6f0]">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <h3 className="jba-display font-medium text-[#1a2942] text-xl sm:text-2xl mb-8 text-center">ほかの関連サイト</h3>
          <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto mb-12">
            {otherRelated.map((it) => (
              <Link key={it.to} to={it.to} className="group flex items-center justify-between bg-white border border-[#e2ddd2] hover:border-[#a38e65]/70 transition-colors duration-300 p-7 text-left">
                <div>
                  <span className="block font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">{it.role}</span>
                  <span className="jba-display font-medium text-[#1a2942] text-lg group-hover:text-[#8f7a56] transition-colors">{it.name}</span>
                </div>
                <span className="text-[#a38e65] text-lg group-hover:translate-x-1 transition-transform">→</span>
              </Link>
            ))}
          </div>
          <div className="bg-[#1a2942] border border-[#a38e65]/45 p-8 sm:p-10 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-xl sm:text-2xl text-[#f8f6f0] mb-6">執事の学びや資格に関心をお持ちの方へ</h3>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
              <Link to="/qualifications" className={BTN08_ON_NAVY}>執事資格制度を見る</Link>
              <Link to="/contact" className={BTN08_ON_NAVY}>お問い合わせ</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
